import Vue from 'vue'
import Vuex from 'vuex'
import { sparkLineChartData, TOP_10_COINS } from './data';

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    charts: sparkLineChartData,
    coins: TOP_10_COINS,
    processedSparkLineData: []
  },
  getters,
  mutations,
  actions
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js